'use strict';
const angular = require('angular');

export class calendarEventDetailComponent {
  /*@ngInject*/
  constructor(dialogs, CalendarEventService, $timeout, $state) {
    this.dialogs = dialogs;
    this.CalendarEventService = CalendarEventService;
    this.$timeout = $timeout;
    this.$state = $state;
  }

  $onInit() {
    this.calendarEvent = this.resolve.calendarEvent;
    this.userHasPermission = this.resolve.config.userHasPermission;
    this.group = this.resolve.config.group;

    if (this.calendarEvent.orig.start)
      this.calendarEvent.orig.start = moment(this.calendarEvent.orig.start);

    if (this.calendarEvent.orig.end)
      this.calendarEvent.orig.end = moment(this.calendarEvent.orig.end);

    this.galleryImages = this.calendarEvent.attachments.filter(attachment => {
      return this.isImageMime(attachment.contentType);
    });

    this.galleryImages = this.galleryImages.map(function(obj){
      var rObj = {};

      rObj.title = obj.filename;
      rObj.alt = obj.filename;
      rObj.url = "/api/storage/" + obj._id;
      rObj.thumbUrl = '/api/storage/' + obj._id + '/thumb';

      return rObj;
    });

    if (this.calendarEvent.location) {

      this.mapOptions = {
        zoom: 15,
        center: new google.maps.LatLng(this.calendarEvent.location.lat, this.calendarEvent.location.lng),
        mapTypeId: google.maps.MapTypeId.TERRAIN
      };

      var that = this;

      this.$timeout(() => {
        that.map = new google.maps.Map(document.getElementById('gMap'), that.mapOptions);

        var marker = new google.maps.Marker({
          map: that.map,
          position: new google.maps.LatLng(that.calendarEvent.location.lat, that.calendarEvent.location.lng),
          title: that.calendarEvent.location.address
        });

        marker.content = '<div class="infoWindowContent">' + that.calendarEvent.location.address + '</div>';

      },500);
    }

  }

  clone() {
    let TARGET = (this.group) ? "calendar-group-edit" : "calendar-edit";
    this.$state.go(TARGET,{type: this.calendarEvent.type, group: this.group, cloneId: this.calendarEvent._id});
    this.ok();
  }

  countPdfAttachments(attachs) {
    return attachs.reduce((acc, obj) => {
      return acc + this.isPdfMime(obj.contentType);
    }, 0);
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  delete() {
    var that = this;
    var eventId = this.calendarEvent._id;

    var dlg = this.dialogs.confirm("Delete this Calendar Event?", "Do you really want to delete this calendar event?");
    dlg.result.then(() => {
      // OK delete it
      that.CalendarEventService.delete({id: eventId},
        () => {
          that.close({$value: {action: 'removed', id: eventId}});
        },
        err => {
          alert("Could not delete calendar event");
        });
    }, () => {
      // Cancel
    });
  }

  ok() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduuApp.calendarEventDetail', [])
  .component('calendarEventDetail', {
    template: require('./calendar-event-detail.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: calendarEventDetailComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/calendar/detail/calendar-event-detail.component.js